import { loadTemplate } from '../template/index.js';
import { renderDetail } from './render.js';



/**
 * Initialize question detail
 * @param {string|null} id - Question ID
 */
export async function initDetail(_id) {
	const container = document.getElementById('detail-question');
	if (!container) return;

	await Promise.all([
		loadTemplate('student-question/detail.ejs'),
		loadTemplate('student-question/empty-detail.ejs')
	]);

	// Initial render is handled by renderQuestionModule in list.js
}

/**
 * Render details for specific question
 * @param {string|null} id - Question ID
 */
export function renderQuestionDetail(id) {
	const container = document.getElementById('detail-question');
	if (!container) return;

	if (!id) {
		renderDetail(container, null);
		return;
	}

	// Get data and render
	import('./store.js').then(({ studentQuestionStore }) => {
		const question = studentQuestionStore.getQuestion(id);
		const userRole = studentQuestionStore.getUserRole();

		if (!question) {
			console.warn('[renderQuestionDetail] Question not found in store for id:', id);
			renderDetail(container, null);
			return;
		}

		renderDetail(container, question, userRole);

		// Nếu là Coach và chưa có câu trả lời, init form phản hồi
		if (userRole === 'coach' && !question.coach_response) {
			initCoachResponseForm(id);
		}

		// Init click "Back to list" for mobile
		const backBtn = container.querySelector('.js-back-to-list');
		if (backBtn) {
			backBtn.onclick = () => {
				import('./handlers.js').then(({ handleMobileNav }) => {
					handleMobileNav(false);
				});
			};
		}
	}).catch(err => {
		console.error('[renderQuestionDetail] Error:', err);
	});
}

/**
 * Initialize Coach Response Form events
 * @param {string} questionId
 */
function initCoachResponseForm(questionId) {
	const textarea = document.getElementById('coach-response-textarea');
	const attachBtn = document.getElementById('btn-coach-attach');
	const sendBtn = document.getElementById('btn-coach-send');
	const fileInput = document.getElementById('coach-file-input');

	if (!textarea || !attachBtn || !sendBtn || !fileInput) return;

	import('./attachment.js').then(({ AttachmentManager }) => {
		const coachAttachment = new AttachmentManager({
			btnId: 'btn-coach-attach',
			inputId: 'coach-file-input',
			previewContainerId: 'coach-file-list',
			wrapperId: 'coach-file-preview'
		});

		// Handle Send Response
		sendBtn.onclick = async () => {
			const content = textarea.value.trim();
			if (!content) {
				const contentWrapper = textarea.closest('.textarea-container');
				contentWrapper.classList.add('error');
				contentWrapper.querySelector('.form-helper-text').textContent = wpcore.direct_t({ en: 'Your response is required.', fr: 'Votre r\u00e9ponse est requise.' });
				return;
			}

			sendBtn.disabled = true;
			sendBtn.textContent = wpcore.direct_t({ en: 'Sending...', fr: 'Envoi en cours...' });

			const files = coachAttachment.getSelectedFiles();

			import('./ajax.js').then(async ({ answerQuestion }) => {
				const result = await answerQuestion({
					id: questionId,
					content: content,
					files: files
				});

				if (result.success) {
					wpcore.alert('success', wpcore.direct_t({ en: 'Response Sent', fr: 'R\u00e9ponse envoy\u00e9e' }), wpcore.direct_t({ en: 'Your response has been sent successfully!', fr: 'Votre r\u00e9ponse a \u00e9t\u00e9 envoy\u00e9e avec succ\u00e8s !' }));
					// Refresh list and detail
					import('./list.js').then(async ({ refreshQuestions }) => {
						await refreshQuestions();
						renderQuestionDetail(questionId);
					});
				} else {
					wpcore.alert('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), result.message || wpcore.direct_t({ en: 'Failed to send response.', fr: '\u00c9chec de l\'envoi de la r\u00e9ponse.' }));
					sendBtn.disabled = false;
					sendBtn.textContent = wpcore.direct_t({ en: 'Send Response', fr: 'Envoyer la r\u00e9ponse' });
				}
			});
		};
	});
}

